import { render } from "./clinic-appointment-history.vue?vue&type=template&id=0cf1be50&scoped=true"
import script from "./clinic-appointment-history.vue?vue&type=script&lang=js"
export * from "./clinic-appointment-history.vue?vue&type=script&lang=js"

import "./clinic-appointment-history.vue?vue&type=style&index=0&id=0cf1be50&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf1be50"]])

export default __exports__